module.exports = __webpack_public_path__ + "img/186.8bbefdce.jpg";